<template>
  <div class="agent-handoff-element">
    <div class="element-header">
      <div class="header-main">
        <div class="icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <!-- Casque support : passage de relais à un agent humain -->
            <path d="M3 18v-6a9 9 0 0 1 18 0v6"/>
            <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3z"/>
            <path d="M3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/>
          </svg>
        </div>
        <span class="element-title">Stop AI & Handoff</span>
      </div>
      <div class="element-actions">
        <button class="action-btn delete-btn" @click.stop="$emit('remove')" title="Supprimer">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          </svg>
        </button>
      </div>
    </div>
    
    <div class="element-body">
      <div class="status-card">
        <div class="status-indicator">
          <span class="pulse-dot"></span>
          <span class="status-text">AI Response Disabled</span>
        </div>
        <p class="status-description">
          Conversation will be paused for the AI. Human agent intervention is required.
        </p>
      </div>

      <div class="meta-info" v-if="localElement.idbot">
        <div class="meta-item">
          <span class="meta-label">Bot Context ID</span>
          <span class="meta-value">{{ localElement.idbot }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgentHandoffElement',
  props: {
    element: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localElement: {}
    };
  },
  watch: {
    element: {
      handler(newVal) {
        this.localElement = JSON.parse(JSON.stringify(newVal));
      },
      deep: true,
      immediate: true
    },
    localElement: {
      handler(newVal) {
        this.$emit('update:element', newVal);
      },
      deep: true
    }
  },
  created() {
    // S'assurer que le composant est bien initialisé
    if (this.localElement.talkToAi === undefined) {
      this.localElement.talkToAi = false;
    }
    if (!this.localElement.type) {
      this.localElement.type = 'agent_handoff';
    }
  }
};
</script>

<style scoped>
.agent-handoff-element {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  transition: all 0.2s ease;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.agent-handoff-element:hover {
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.08);
  border-color: #fecaca;
}

.element-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #fef2f2; /* Light red bg */
  border-bottom: 1px solid #fee2e2;
}

.element-actions {
  display: flex;
  gap: 8px;
  opacity: 0.6;
  transition: opacity 0.2s;
}

.agent-handoff-element:hover .element-actions {
  opacity: 1;
}

.action-btn {
  background: white;
  border: 1px solid #fee2e2;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  transition: all 0.2s ease;
  width: 28px;
  height: 28px;
}

.action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.delete-btn:hover {
  background: #fef2f2;
  border-color: #fca5a5;
  color: #ef4444;
}

.header-main {
  display: flex;
  align-items: center;
  gap: 10px;
}

.icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: #ffffff;
  border-radius: 6px;
  color: #ef4444;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.element-title {
  font-weight: 600;
  color: #991b1b;
  font-size: 0.95rem;
}

.element-body {
  padding: 16px;
}

.status-card {
  background: #fff5f5;
  border: 1px solid #fed7d7;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.pulse-dot {
  width: 8px;
  height: 8px;
  background-color: #ef4444;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);
}

.status-text {
  font-weight: 600;
  color: #c53030;
  font-size: 0.9rem;
  letter-spacing: 0.02em;
}

.status-description {
  margin: 0;
  font-size: 0.85rem;
  color: #718096;
  line-height: 1.4;
}

.meta-info {
  margin-bottom: 0px; /* Reduced margin since debug is gone */
  padding: 0 4px;
}

.meta-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  background: #f8fafc;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #f1f5f9;
}

.meta-label {
  color: #64748b;
  font-weight: 500;
}

.meta-value {
  font-family: 'Fira Code', monospace;
  color: #334155;
  font-weight: 600;
}
</style>
